module.exports = __webpack_public_path__ + "assets/icon-close-window.205750af.svg";